<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <div class="p_container">
        <div clsss="p_wrapper" style="text-align: center; font-size: 9pt;">
          <div class="image_container" :class="{no_image: frontPhotoes.length === 0}">
            <!-- <img v-if="frontPhoto" :src="getPhotoPath(frontPhoto)"> -->
            <vue-viewer v-if="frontPhotoes && frontPhotoes.length > 0" :thumb="frontPhotoes[0]" :full="frontPhotoes[1]" />
            <span v-else>尚未上传</span>
          </div>
          <div>正面照</div>
        </div>
        <div clsss="p_wrapper" style="text-align: center; font-size: 9pt;">
          <div class="image_container" :class="{no_image: reversePhotoes.length === 0}">
            <vue-viewer v-if="reversePhotoes && reversePhotoes.length > 0" :thumb="reversePhotoes[0]" :full="reversePhotoes[1]" />
            <span v-else>尚未上传</span>
          </div>
          <div>侧面照</div>
        </div>
        <div clsss="p_wrapper" style="text-align: center; font-size: 9pt;">
          <div class="image_container" :class="{no_image: powerPhotoes.length === 0}">
            <!-- <img v-if="frontPhoto" :src="getPhotoPath(frontPhoto)"> -->
            <vue-viewer v-if="powerPhotoes && powerPhotoes.length > 0" :thumb="powerPhotoes[0]" :full="powerPhotoes[1]" />
            <span v-else>尚未上传</span>
          </div>
          <div>充电器</div>
        </div>
        <!-- <div clsss="p_wrapper" style="text-align: center; font-size: 9pt;">
          <div class="image_container">
            <img v-if="frontPhoto" :src="getPhotoPath(frontPhoto)">
          </div>
          <div>侧面照</div>
        </div> -->
      </div>
    </div>
    <div slot="footer">
      <Button
        size="small"
        icon="ios-checkmark-circle-outline"
        @click="closeModal"
      >
        关闭
      </Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'VehiclePhoto',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 500
    },
    vehicleNumber: {
      type: String,
      default: ''
    },
    vehiclePhotoes: {
      type: Array,
      default() { return [] }
    }
  },
  data() {
    return {
      loadingStatus: false
    }
  },
  computed: {
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    frontPhotoes() {
      const extension = this.$config.imageFileExt
      const storageHost = this.$config.storageHost
      if (this.vehiclePhotoes && this.vehiclePhotoes.length > 0) {
        if (this.vehiclePhotoes[0]) {
          const path = storageHost + '/photo/' + this.vehiclePhotoes[0] + '/' + this.vehiclePhotoes[0]
          return [path + '_200x200' + extension, path + extension]
        }
      }
      return []
    },
    reversePhotoes() {
      const extension = this.$config.imageFileExt
      const storageHost = this.$config.storageHost
      if (this.vehiclePhotoes && this.vehiclePhotoes.length > 1) {
        if (this.vehiclePhotoes[1]) {
          const path = storageHost + '/photo/' + this.vehiclePhotoes[1] + '/' + this.vehiclePhotoes[1]
          return [path + '_200x200' + extension, path + extension]
        }
      }
      return []
    },
    powerPhotoes() {
      const extension = this.$config.imageFileExt
      const storageHost = this.$config.storageHost
      if (this.vehiclePhotoes && this.vehiclePhotoes.length > 2) {
        if (this.vehiclePhotoes[2]) {
          const path = storageHost + '/photo/' + this.vehiclePhotoes[2] + '/' + this.vehiclePhotoes[2]
          return [path + '_200x200' + extension, path + extension]
        }
      }
      return []
    },
    title() {
      return '车辆图片 - ' + this.vehicleNumber
    }
  },
  methods: {
    getPhotoPath(name) {
      return this.$config.storageHost + '/photo/' + name + '/' + name + this.$config.imageFileExt
    },
    closeModal: function() {
      this.$emit('on-close', false)
    }
  }
}
</script>

<style lang="less">
    .p_container {
        display: flex;
        justify-content: space-around;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .image_container {
        height: 100px;
        width: 100px;
        border: 1px solid #ccc;
        padding: 4px;
        margin-bottom: 5px;
        cursor: zoom-in;
    }
    .no_image {
        align-items: center;
        display: flex;
        justify-content: center;
    }
    .p_wrapper {
        text-align: center;
    }
</style>
